import { useState } from 'react';
import { T } from '../theme';

/**
 * Section landing : rapport de match réel (données anonymisées).
 * Gauche = "Ton équipe" (bleu) · Droite = "Adversaire" (or)
 */

// ── UNE SEULE CONVENTION D'EQUIPE, PARTAGEE AVEC LE RAPPORT ────────────────
//
// Le bleu portait deja le bon role ici — « ton equipe ». C'est l'ADVERSAIRE qui
// etait en rouge (`RED = '#C0392B'`, le rouge du prestataire que theme.js
// declare elimine), et RapportPublic faisait l'inverse : le rouge sur l'equipe
// du coach. Deux surfaces publiques, deux conventions opposees, aucune des deux
// d'accord avec le rapport. Voir P0-COULEUR-EQUIPE-PUBLIC-001.
//
// LE ROUGE NE DESIGNE JAMAIS UNE EQUIPE · il est reserve a la performance
// (`repDown`), qui dit un ecart defavorable et pas qui l'a subi.
//
// APLAT ou TEXTE · une couleur d'identite posee en aplat n'a pas de contrainte
// de contraste, une couleur ECRITE en a une. D'ou deux sorties par equipe.
const US = T.repUs;             // aplats seulement · 3.21:1 sur blanc
const US_INK = T.repUsInk;      // toute identite ECRITE de notre equipe
const THEM = T.repThem;         // aplats seulement · 2.17:1 sur blanc
const THEM_INK = T.repThemInk;  // toute identite ECRITE de l'adversaire
// Accent d'interface — filet, bordure, onglet, mention. PAS une equipe.
const ACCENT = T.blue;
const BLACK = '#0A0A0A';
const GREEN = '#3DBF7A';
const GREEN_DARK = '#2E9E63';

// LA VITRINE NE MONTRE QUE CE QUE LE PRODUIT SAIT PRODUIRE.
//
// Ce composant est monte sur la PAGE D'ACCUEIL publique, donc indexee et vue
// par des prospects qui ne parleront peut-etre jamais a personne. Ce qu'il
// affiche est une promesse commerciale, pas une illustration.
//
// REGLE — si un bloc est retire du rapport (MatchAnalyseReport.jsx), il est
// retire d'ici dans le meme geste.
//
// Retires le 04/08/2026, en meme temps que du rapport ·
//   - le bloc « Tirs » (tentes et cadres) · le bloc `cartographies` n'est
//     jamais produit par le prestataire, et « Tirs cadres » avait deja quitte
//     le mapper le 03/08 faute de vocabulaire qualifie.
//   - la mention du but (« But : ton équipe, 25e ») · le pipeline attribue mal
//     les buts, ce qui a fait retirer le bloc Buts du rapport.
//
// Les quatre blocs restants sont produits par le pipeline.
const DATA = {
  full: {
    score: ['1', '0'],
    poss: [[42, 58, 'Possession', '%'], [41, 27, 'Possession · tiers défensif', '%'], [43, 48, 'Possession · tiers médian', '%'], [16, 25, 'Possession · tiers offensif', '%']],
    pass: [[184, 292, 'Passes réussies', ''], [79, 81, 'Précision de passe', '%'], [44, 35, "Passes vers l'avant", '%'], [37, 45, 'Passes latérales', '%'], [19, 20, "Passes vers l'arrière", '%']],
    att: [[26, 42, 'Attaques aile gauche', '%'], [30, 30, "Attaques dans l'axe", '%'], [44, 28, 'Attaques aile droite', '%']],
    duel: [[72, 62, 'Ballons récupérés', ''], [63, 74, 'Ballons perdus', ''], [19, 20, 'Récupérations en - de 5 s', ''], [7, 6, 'Transitions offensives (- 6 s)', ''], [9, 14, 'Ballons touchés surface adverse', '']],
    zone: [['Zone défensive', 24, 14, 21, 11], ['Zone milieu', 34, 33, 30, 41], ['Zone offensive', 14, 16, 11, 22]],
  },
  p1: {
    score: ['1', '0'],
    poss: [[47, 53, 'Possession', '%'], [30, 35, 'Possession · tiers défensif', '%'], [50, 45, 'Possession · tiers médian', '%'], [20, 20, 'Possession · tiers offensif', '%']],
    pass: [[142, 174, 'Passes réussies', ''], [82, 82, 'Précision de passe', '%'], [40, 35, "Passes vers l'avant", '%'], [40, 45, 'Passes latérales', '%'], [20, 20, "Passes vers l'arrière", '%']],
    att: [[30, 40, 'Attaques aile gauche', '%'], [30, 35, "Attaques dans l'axe", '%'], [40, 25, 'Attaques aile droite', '%']],
    duel: [[44, 38, 'Ballons récupérés', ''], [39, 42, 'Ballons perdus', ''], [15, 12, 'Récupérations en - de 5 s', ''], [5, 3, 'Transitions offensives (- 6 s)', ''], [6, 4, 'Ballons touchés surface adverse', '']],
    zone: [['Zone défensive', 12, 6, 15, 7], ['Zone milieu', 24, 23, 18, 25], ['Zone offensive', 8, 10, 5, 10]],
  },
  p2: {
    score: ['0', '0'],
    poss: [[38, 62, 'Possession', '%'], [55, 20, 'Possession · tiers défensif', '%'], [35, 50, 'Possession · tiers médian', '%'], [10, 30, 'Possession · tiers offensif', '%']],
    pass: [[42, 118, 'Passes réussies', ''], [70, 79, 'Précision de passe', '%'], [55, 35, "Passes vers l'avant", '%'], [30, 45, 'Passes latérales', '%'], [15, 20, "Passes vers l'arrière", '%']],
    att: [[20, 45, 'Attaques aile gauche', '%'], [30, 25, "Attaques dans l'axe", '%'], [50, 30, 'Attaques aile droite', '%']],
    duel: [[28, 24, 'Ballons récupérés', ''], [24, 32, 'Ballons perdus', ''], [4, 8, 'Récupérations en - de 5 s', ''], [2, 3, 'Transitions offensives (- 6 s)', ''], [3, 10, 'Ballons touchés surface adverse', '']],
    zone: [['Zone défensive', 12, 8, 6, 4], ['Zone milieu', 10, 10, 12, 16], ['Zone offensive', 6, 6, 6, 12]],
  },
};

const TABS = [
  { id: 'full', label: 'Match complet' },
  { id: 'p1', label: '1re période' },
  { id: 'p2', label: '2e période' },
];

function StatRow({ a, b, label, unit }) {
  const total = a + b || 1;
  const pa = (a / total) * 100;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '48px 1fr 48px', alignItems: 'center', gap: 12, marginBottom: 12 }}>
      <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 20, fontWeight: 800, lineHeight: 1, textAlign: 'right', color: US_INK }}>
        {a}{unit}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
        <div style={{ fontSize: 11, color: '#555', textAlign: 'center', lineHeight: 1.25 }}>{label}</div>
        <div style={{ display: 'flex', width: '100%', height: 5, borderRadius: 3, overflow: 'hidden', background: '#F0F0F0' }}>
          <div style={{ background: US, width: `${pa}%` }} />
          <div style={{ background: THEM, width: `${100 - pa}%` }} />
        </div>
      </div>
      <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 20, fontWeight: 800, lineHeight: 1, textAlign: 'left', color: THEM_INK }}>
        {b}{unit}
      </div>
    </div>
  );
}

function Group({ title, rows }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{
        fontFamily: "'Barlow Condensed', sans-serif", fontSize: 15, fontWeight: 800,
        letterSpacing: '1.2px', textTransform: 'uppercase', color: BLACK,
        marginBottom: 16, paddingBottom: 8, borderBottom: '1px solid #EBEBEB',
        display: 'flex', alignItems: 'center', gap: 8,
      }}>
        <span style={{ width: 3, height: 13, background: ACCENT, display: 'inline-block', flex: 'none' }} />
        {title}
      </div>
      {rows.map(([a, b, label, unit], i) => (
        <StatRow key={i} a={a} b={b} label={label} unit={unit} />
      ))}
    </div>
  );
}

function ZoneTable({ zone }) {
  const th = { fontSize: 9, letterSpacing: '1px', textTransform: 'uppercase', fontWeight: 600 };
  const num = { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 17, fontWeight: 800, color: BLACK };
  const numMut = { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 17, fontWeight: 600, color: '#AAA' };
  // FOND BLANC, PAS #FAFAFA · sur le gris, `repThemInk` tombe a 4.37:1 et
  // `repUsInk` a 5.25:1. Le bloc se detache par sa BORDURE, jamais par un
  // aplat. Meme regle que .rp-zone dans RapportPublic.
  return (
    <div style={{ background: '#fff', border: '0.5px solid #EBEBEB', padding: 16 }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr 1fr 1fr 1fr', paddingBottom: 9, borderBottom: '1px solid #E5E5E5' }}>
        <span style={{ ...th, color: '#555' }}>Pertes &amp; récup. / zone</span>
        <span style={{ ...th, color: US_INK }}>récup</span>
        <span style={{ ...th, color: US_INK }}>perdus</span>
        <span style={{ ...th, color: THEM_INK }}>récup</span>
        <span style={{ ...th, color: THEM_INK }}>perdus</span>
      </div>
      {zone.map((r, i) => (
        <div key={i} style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr 1fr 1fr 1fr', alignItems: 'center', padding: '9px 0', borderBottom: i < zone.length - 1 ? '0.5px solid #F0F0F0' : 'none' }}>
          <span style={{ fontSize: 11, color: '#555' }}>{r[0]}</span>
          <span style={num}>{r[1]}</span>
          <span style={numMut}>{r[2]}</span>
          <span style={num}>{r[3]}</span>
          <span style={numMut}>{r[4]}</span>
        </div>
      ))}
    </div>
  );
}

export default function MatchReportShowcase() {
  const [tab, setTab] = useState('full');
  const d = DATA[tab];

  return (
    <section style={{ background: '#F7F7F7', padding: '64px 32px', fontFamily: "'Space Grotesk', sans-serif" }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>

        <div style={{ marginBottom: 28 }}>
          <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: '2.5px', textTransform: 'uppercase', color: '#999', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ width: 18, height: 1, background: '#999', display: 'inline-block' }} />
            Rapport de match
          </div>
          <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 'clamp(30px, 5vw, 40px)', fontWeight: 900, textTransform: 'uppercase', lineHeight: 0.92, color: BLACK, letterSpacing: '-0.5px' }}>
            Vidéo envoyée.<br /><span style={{ color: ACCENT }}>Rapport reçu.</span>
          </h2>
        </div>

        <div style={{ background: '#fff', border: '0.5px solid #E5E5E5', borderTop: `2.5px solid ${ACCENT}` }}>

          {/* Scoreline */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', padding: '22px 28px 18px', borderBottom: '1px solid #EBEBEB', gap: 20 }}>
            <div style={{ gridColumn: '1/-1', fontSize: 9, letterSpacing: '2px', textTransform: 'uppercase', color: '#999', textAlign: 'center', marginBottom: 14, fontWeight: 500 }}>
              National 2 · Journée 30 · Saison 2025-26
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', textAlign: 'right' }}>
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 22, fontWeight: 900, textTransform: 'uppercase', letterSpacing: '0.5px', lineHeight: 1, color: US_INK }}>Ton équipe</div>
              <div style={{ fontSize: 9, letterSpacing: '1.5px', textTransform: 'uppercase', color: '#555', fontWeight: 600, marginTop: 6 }}>Extérieur</div>
            </div>
            <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 'clamp(40px, 7vw, 52px)', fontWeight: 900, color: BLACK, letterSpacing: '-1px', lineHeight: 1, whiteSpace: 'nowrap' }}>
              {d.score[0]}<span style={{ color: '#D8D8D8' }}>–</span>{d.score[1]}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 22, fontWeight: 900, textTransform: 'uppercase', letterSpacing: '0.5px', lineHeight: 1, color: THEM_INK }}>Adversaire</div>
              <div style={{ fontSize: 9, letterSpacing: '1.5px', textTransform: 'uppercase', color: '#555', fontWeight: 600, marginTop: 6 }}>Domicile</div>
            </div>
          </div>

          {/* Tabs */}
          <div style={{ display: 'flex', borderBottom: '1px solid #EBEBEB' }}>
            {TABS.map((t) => {
              const active = tab === t.id;
              return (
                <button
                  key={t.id}
                  onClick={() => setTab(t.id)}
                  style={{
                    flex: 1,
                    textAlign: 'center',
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: '1px',
                    textTransform: 'uppercase',
                    padding: '14px 8px',
                    minHeight: 44,
                    cursor: 'pointer',
                    fontFamily: "'Space Grotesk', sans-serif",
                    color: active ? ACCENT : '#999',
                    background: 'transparent',
                    border: 'none',
                    borderBottom: `2px solid ${active ? ACCENT : 'transparent'}`,
                    outline: 'none',
                    transition: 'color .12s',
                  }}
                >
                  {t.label}
                </button>
              );
            })}
          </div>

          {/* Body */}
          <div className="ib-report-body" style={{ padding: '26px 28px 28px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 30 }}>
            <div>
              <Group title="Possession" rows={d.poss} />
              <Group title="Passes" rows={d.pass} />
            </div>
            <div>
              <Group title="Origine des attaques" rows={d.att} />
              <Group title="Duels &amp; transitions" rows={d.duel} />
              <ZoneTable zone={d.zone} />
            </div>
          </div>

          {/* Footer */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 28px', borderTop: '1px solid #EBEBEB', background: '#FAFAFA' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 10, fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase', color: GREEN_DARK }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: GREEN, display: 'inline-block' }} />
              Analyse complète · 100%
            </span>
            <span style={{ fontSize: 11, fontWeight: 600, color: ACCENT }}>Rapport PDF disponible ↓</span>
          </div>

        </div>

        <div style={{ marginTop: 28 }}>
          <a href="/#contact" style={{ display: 'inline-block', background: BLACK, color: '#fff', fontSize: 11, fontWeight: 600, letterSpacing: '0.4px', padding: '14px 24px', borderRadius: 3, textDecoration: 'none' }}>
            Demander une démo pour votre club →
          </a>
        </div>

      </div>

      <style>{`
        @media (max-width: 820px) {
          .ib-report-body { grid-template-columns: 1fr !important; gap: 22px !important; padding: 20px 16px 24px !important; }
        }
      `}</style>
    </section>
  );
}
